import { useCallback, useEffect, useState } from 'react'
import { MOBILE_MEDIA_QUERY, isMobileViewport } from '@/hooks/use-is-mobile'

export function useResponsiveSidebar() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => isMobileViewport())

  useEffect(() => {
    if (typeof window === 'undefined') return

    const query = window.matchMedia(MOBILE_MEDIA_QUERY)
    const syncSidebarState = () => setSidebarCollapsed(query.matches)

    syncSidebarState()
    query.addEventListener('change', syncSidebarState)
    return () => query.removeEventListener('change', syncSidebarState)
  }, [])

  const closeSidebarOnMobile = useCallback(() => {
    if (isMobileViewport()) setSidebarCollapsed(true)
  }, [])

  return { sidebarCollapsed, setSidebarCollapsed, closeSidebarOnMobile }
}
